import React from 'react';
import { useStyletron } from 'baseui';
import type { GetULabelConfigFunction } from '../../../../common/providers/feature-flag-provider';
import useResizeObserver from '../../../hooks/useResizeObserver.react';
import { HoveredFrameContainer } from './hovered-frame/hovered-frame-container';
type PropsT = {
  container: HTMLDivElement | null;
  getULabelConfig: GetULabelConfigFunction | null;
};
type OverlayContentProps = {
  container: HTMLDivElement;
  getULabelConfig: GetULabelConfigFunction | null;
};
const OverlayContent = ({
  container,
  getULabelConfig
}: OverlayContentProps) => {
  const [css] = useStyletron();
  const containerDimensions = useResizeObserver(container);
  return <div className={css({
    width: '100%',
    height: '100%'
  })}>
      <HoveredFrameContainer container={container} containerDimensions={containerDimensions} getULabelConfig={getULabelConfig} />
    </div>;
};
export function StageOverlayElements({
  container,
  getULabelConfig
}: PropsT) {
  if (!container) {
    return null;
  }
  return <OverlayContent container={container} getULabelConfig={getULabelConfig} />;
}